import React, { useMemo, useState } from 'react';
import style from './legacy-style.module.css';
import { IDisplayExistingCustomer } from './types';
import CustomerDetailDisplay from 'design-v2/common/CustomerTab/CustomerDetailDisplay';
import { IconTypes } from 'external-services/icons-service/icons.types';
import color from 'design-v2/globals/colors/colors.module.css';
import Checkbox from '@material-ui/core/Checkbox';
import classNames from 'classnames';
import typ from 'design-v2/globals/typography.module.css';
import Box from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core';
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';


const NS = 'DisplayExistingCustomer'

const classPrefix = 'ExistingCustomerDisplay';
const DisplayExistingCustomer = (props: IDisplayExistingCustomer) => {
  const {
    customer,
    isBookedBy,
    toggleEmailSmsNotification,
    disableEmailSmsNotification,
    titleSubscription
  } = props;
  const fullName = customer?.firstName ? `${customer.firstName} ${customer.lastName || ''}` : (customer?.lastName || '');
  const birthdayArray = [customer?.birthdayDate, customer?.birthdayMonth, customer?.birthdayYear].filter((value) => !!value);
  let birthdayString = '';

  /**
   * for the birthday, we'll not display single value(eg: only date, only month or only year)
   * we'll not display if there's combination of day + year
   */
  if (birthdayArray.length >= 2 && customer?.birthdayMonth) {
    birthdayString = birthdayArray.join('-');
  }
  const [showMoreDetails, setShowMoreDetails] = useState<boolean>(false);

  const handleShowMoreDetails = () => {
    setShowMoreDetails(!showMoreDetails);
  }


  return (
    <div className={style.rootContainer}>
      <div className={style.mainContainer}>
        <div
          className={classNames({
            [style.flexContainer]: true,
            [style.mainContainer]: true,
          })}
        >
          <div
            className={classNames({
              [style.customerLeftInfo]: true,
              [style.verticalSpaceM]: true,
            })}
          >
            <div className={style.customizeLine}>
              <CustomerDetailDisplay
                icon={IconTypes.callOutlinedIcon}
                detail={customer?.phone}
                label={'Phone'}
                includeIcons={true}
              />
            </div>
            <div className={style.customizeLine}>
              <CustomerDetailDisplay
                icon={IconTypes.accountBoxOutlinedIcon}
                detail={fullName}
                label={'Customer name'}
                tailPart={customer?.visitCount ? `${customer?.visitCount} Visits` : ''}
                includeIcons={true}
              />
            </div>

            <div className={style.customizeLine}>
              <CustomerDetailDisplay
                icon={IconTypes.mailOutlineIcon}
                detail={customer?.email}
                label={'Email'}
                includeIcons={true}
              />
            </div>
            <div className={style.customizeLine}>
              <CustomerDetailDisplay
                icon={IconTypes.locationCityIcon}
                detail={customer?.company}
                label={'Company'}
                includeIcons={true}
              />
            </div>
          </div>
          <div className={style.customerRightInfo}>
            <div onClick={handleShowMoreDetails} className={style.showMoreDetailsContainer}>
              {showMoreDetails ? (
                <ExpandLessOutlinedIcon color={'disabled'} />
              ) : (
                <ExpandMoreOutlinedIcon color={'disabled'} />
              )}
              <div className={style.showMoreDetails}>
                {showMoreDetails ? 'Hide more details' : 'Show more details'}
              </div>
            </div>
            {showMoreDetails && (
              <div>
                <div className={style.customizeLine}>
                  <CustomerDetailDisplay
                    icon={IconTypes.addIcCallOutlinedIcon}
                    detail={customer?.phone2}
                    label={'Additional phone'}
                    includeIcons={true}
                  />
                </div>
                <div className={style.customizeLine}>
                  <CustomerDetailDisplay
                    icon={IconTypes.locationOnOutlinedIcon}
                    detail={customer?.streetAddress}
                    label={'Street Address'}
                    includeIcons={true}
                  />
                </div>
                <div className={style.flexLine}>
                  <div className={style.suburb}>
                  <CustomerDetailDisplay
                    icon={IconTypes.locationOnOutlinedIcon}
                    detail={customer?.suburb}
                    label={'Suburb'}
                    includeIcons={true}
                  />
                  </div>
                  <div className={style.postcode}>
                  <CustomerDetailDisplay
                    detail={customer?.postcode}
                    label={'Postcode'}
                    iconStyle={{ height: 27, width: 0 }}
                    // muiIcon={<div style={{height: "27px"}}/>}
                    includeIcons={true}
                  />
                  </div>


                </div>

                <div className={style.customizeLine}>
                  <CustomerDetailDisplay
                    icon={IconTypes.cakeIcon}
                    detail={birthdayString ? birthdayString : ''}
                    label={'Birthday'}
                    includeIcons={true}
                  />
                </div>
                <div className={style.customizeLine}>
                  <CustomerDetailDisplay
                    icon={IconTypes.customers}
                    detail={customer?.membershipNumber}
                    label={'Membership Number'}
                    includeIcons={true}
                  />
                </div>
              </div>
            )}
            <div
              className={classNames({
                [style.flexContainer]: true,
                [style.titleSubscribeContainer]: true,
              })}
            >
              <Checkbox checked={!!customer?.subscribed} disabled={true} />
              {titleSubscription || 'Subscribed to mailing list'}
            </div>

            <div
              className={classNames({
                [style.flexContainer]: true,
                [style.subscribeContainer]: true,
              })}
            >
              <Checkbox
                color="primary"
                checked={disableEmailSmsNotification}
                onChange={(event) => toggleEmailSmsNotification(event.target.checked)}
              />
              Do not send emails or SMS
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default DisplayExistingCustomer;
